import ColoredAlert from '../global/ColoredAlert';
import useGetSubscriptionFromStripe from '../../hooks/subscriptions/useGetSubscriptionFromStripe';
import {
  convertStripeStatus,
  getSubscriptionModalContentFromStatus,
} from '../../helpers/subscriptions';

function PaymentFailedAlert() {
  const stripeQuery = useGetSubscriptionFromStripe();
  const { isPaymentFailed } = stripeQuery.state || {};
  const { status } = stripeQuery.data || {};

  if (!isPaymentFailed || !status) return null;

  const content = getSubscriptionModalContentFromStatus(
    convertStripeStatus(status),
  );

  if (!content) return null;

  return (
    <ColoredAlert
      animate={false}
      title={content.title}
      subtitle={content.description}
      type="error"
      dismissible={false}
    />
  );
}

export default PaymentFailedAlert;
